export const API_URL = "https://e-bialalistapodatnikow.pl/server/api";

export const API_URL_GOV = "https://wl-api.mf.gov.pl/api/search";



